import { Button } from 'common/Components/Button';
import Captcha from 'common/Components/Captcha';
import { stringToBase64 } from 'common/method/helper';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useGetCaptch } from 'services/login';
import { yupResolver } from '@hookform/resolvers/yup';
import 'react-simple-keyboard/build/css/index.css';
import { changePasswordValidate } from 'common/validations/changePassword';
import { toast } from 'react-toastify';
import { RadioValidate } from 'pages/ChangePassword/SetPassword/Components/RadioValidate';
import { useForgetChangePassword } from 'services/forgetPassword';
import { useRouter } from 'common/hooks/useRouter';
import { PasswordInput } from 'common/Components/form/paswordInput';
import { useTranslation } from 'react-i18next';

type formDate = {
  isForget: boolean;
  newPassword: string;
  newPasswordConfirm: string;
  captchaValue: string;
};

export const FormForgetChange = () => {
  //*global
  const { data: captcha, refetch: refetchCaptcha } = useGetCaptch();
  const {
    navigate,
    history: {
      state: { mobile, nationalCode },
    },
  } = useRouter();

  const { t } = useTranslation();

  //*form
  const schema = changePasswordValidate()


  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    resetField,
    watch,
    formState: { errors },
  } = useForm<formDate>({
    defaultValues: {
      isForget: true, ////////isForget just use for validation
      newPassword: '',
      newPasswordConfirm: '',
      captchaValue: '',
    },
    mode: 'onChange',
    resolver: yupResolver(schema as any),
  });

  const onSubmit: SubmitHandler<formDate> = (data) => {
    if (!captcha?.key) {
      handleRefetchCaptch();
      return;
    }

    const otp = sessionStorage.getItem('otp') || '';
    const otpRes = JSON.parse(otp);
    mutate({
      captchaKey: captcha.key,
      captchaValue: data.captchaValue,
      mobile: mobile,
      nationalCode: nationalCode,
      newPassword: stringToBase64(data.newPassword),
      otp: otpRes,
    });
  };

  //*hanle methode
  const handleRefetchCaptch = (): void => {
    refetchCaptcha();
    resetField('captchaValue');
  };

  //*ForgetChangePassword API
  const { mutate } = useForgetChangePassword({
    onSuccess: (data) => {
      const { succeeded } = data;
      if (succeeded) {
        toast.success('رمز عبور جدید با موفقیت انجام شد');
        const clear = setTimeout(() => {
          navigate.pushLogin();
          clearTimeout(clear);
        }, 2000);
      } else {
        handleRefetchCaptch();
      }
    },
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <PasswordInput
        setValues={setValue}
        register={register}
        error={errors.newPassword}
        name="newPassword"
        labelInput={t(`FormSide.Input.NewPassword.Label`)}
        watch={watch}
        placeHolder={t(`FormSide.Input.NewPassword.Placeholder`)}
      />

      <RadioValidate value={watch('newPassword')} />

      <div className="mt-6">
        <PasswordInput
          setValues={setValue}
          register={register}
          error={errors.newPasswordConfirm}
          name="newPasswordConfirm"
          labelInput={t(`FormSide.Input.ConfirmNewPassword.Label`)}
          placeHolder={t(`FormSide.Input.ConfirmNewPassword.Placeholder`)}
          watch={watch}
        />
      </div>

      <Captcha
        register={register}
        errors={errors}
        captcha={captcha}
        onRefresh={handleRefetchCaptch}
        className="mt-6 md:mt-6"
        setValue={setValue}
        getValues={getValues}
      />

      <div className="mt-5">
        <Button
          type="submit"
          className="w-full bg-L-secondary-50 rounded text-L-basic p-2"
        >
          {t(`FormSide.Confirm.ForgetPassword`)}
        </Button>
        <Button
          type="button"
          className="w-full mt-2 p-2 text-L-gray-300"
          onClick={(e) => {
            e.preventDefault()
            navigate.pushLogin()
          }}
        >
          {t(`FormSide.CancelText`)}
        </Button>
      </div>
    </form>
  );
};
